import * as React from 'react';
import { trackNewbuildingFilterButtonClick } from '../tracking';
import * as styles from './NewbuildingGkButton.css';

export interface INewbuildingGkButtonProps {
  showExperimentButton: boolean;

  makeNewbuildingSearch(): void;
}

export class NewbuildingGkButtonComponent extends React.PureComponent<INewbuildingGkButtonProps> {
  private makeSearch = () => {
    trackNewbuildingFilterButtonClick();

    return this.props.makeNewbuildingSearch();
  };

  public render() {
    const { showExperimentButton } = this.props;

    if (!showExperimentButton) {
      return null;
    }

    return (
      <div className={styles['container']}>
        <button className={styles['button']} type="button" onClick={this.makeSearch}>
          <span className={styles['button-text']}>Показать ЖК</span>
        </button>
      </div>
    );
  }
}
